import classNames from 'classnames';
import './Divider.scss';

export const DIVIDER_VARIANTS = ['primary', 'secondary'] as const;

export type DividerVariant = (typeof DIVIDER_VARIANTS)[number];

export interface DividerProps {
  /** If true set the divider to vertical. Default false (horizontal). */
  vertical?: boolean;
  /** Style variant primary or secondary. Default primary. */
  variant?: DividerVariant;
  className?: string;
}

/**
 * Divider Component
 * @param vertical If true set the divider to vertical. Default false (horizontal).
 * @param variant style variant primary or secondary. Default primary.
 * @param className additional class name
 * @constructor
 */
export const Divider: React.FC<DividerProps> = ({
  vertical = false,
  variant = 'primary',
  className,
  ...rest
}) => {
  return (
    <hr
      {...rest}
      className={classNames('vds-divider', className, {
        'vds-divider--vertical': vertical,
        [`vds-divider--${variant}`]: variant,
      })}
      aria-hidden="true"
    />
  );
};
